import type { DateRangePreset } from "../dashboard/dateSelection";
import { buildHash } from "../../utils/urlHash";

export function processScopeHash(
  userIds: string[] | "all",
  dates?: { from: string; to: string; preset?: DateRangePreset },
) {
  const params = new URLSearchParams({ pu: userIds === "all" ? "all" : userIds.join(",") });
  if (dates) {
    if (dates.preset && dates.preset !== "custom") params.set("period", dates.preset);
    else if (!dates.from && !dates.to) params.set("period", "all");
    else {
      if (dates.from) params.set("from", dates.from);
      if (dates.to) params.set("to", dates.to);
    }
  }
  return buildHash("", params);
}

export function processDetailHref(
  slug: string,
  userIds: string[] | "all",
  dates?: Parameters<typeof processScopeHash>[1],
) {
  return `/processes/${encodeURIComponent(slug)}/${processScopeHash(userIds, dates)}`;
}
